import ExploreOtherSection from "./ExploreOtherSection";
import { BookedCard } from "./BookedCard";

const Booked = () => {
  return (
    <div>
      <div className="w-[100%] my-8">
        <div className="flex gap-3 overflow-x-scroll no-scrollbar pl-6 ">
          {Array.from({ length: 9 })?.map((ele, i) => (
            <BookedCard key={i} />
          ))}
        </div>
      </div>
      <ExploreOtherSection />
    </div>
  );
};

export default Booked;
